import { TypographyFontSize, TypographyFontFamily } from '@design-system/components/atoms/typography/entities/typography.types';

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum ButtonSize {
  RG = 'rg',
  SM = 'sm',
  SquareSM = 'square-sm',
  SquareRG = 'square-rg'
}

export interface ButtonSizeConfigProps {
  FontSize: TypographyFontSize;
  Height: string;
  FontFamily: TypographyFontFamily;
  IconSize: number;
  LoaderSize: string;
}

export interface ButtonLabels {
  ButtonLabel: string;
  BasketLabel?: string;
}

export enum ButtonWidth {
  Stretch = '100%',
  Fit = 'auto',
}

export const ButtonSizeConfig: { [key: string]: ButtonSizeConfigProps } = {
  [ButtonSize.RG]: {
    FontSize: TypographyFontSize.XS,
    Height: '48px',
    FontFamily: TypographyFontFamily.SemiBold,
    IconSize: 20,
    LoaderSize: '20px',
  },
  [ButtonSize.SM]: {
    FontSize: TypographyFontSize.XXS,
    Height: '36px',
    FontFamily: TypographyFontFamily.SemiBold,
    IconSize: 16,
    LoaderSize: '16px',
  },
  [ButtonSize.SquareRG]: {
    FontSize: TypographyFontSize.LG,
    Height: '64px',
    FontFamily: TypographyFontFamily.SemiBold,
    IconSize: 24,
    LoaderSize: '20px',
  },
  [ButtonSize.SquareSM]: {
    FontSize: TypographyFontSize.RG,
    Height: '50px',
    FontFamily: TypographyFontFamily.SemiBold,
    IconSize: 24,
    LoaderSize: '20px',
  },
}
